module.exports = __webpack_public_path__ + "img/galardon.153166e9.png";